import { GenericServiceRequest } from './generic-service-request';
import { FindOptions } from '../domain-models/find-options/find-options';

export class FindRequest extends GenericServiceRequest<FindOptions> {

}
